import { getApiUrl } from "../../services/apiConfig.js";
/* Turmas, tarefas e relatórios. Cada resposta permanece no servidor da instituição. */
(function () {
  "use strict";

  const handleAction = (tag, cls, text) => {
    const createElementResult = document.createElement(tag);
    if (cls) createElementResult.className = cls;
    if (text !== undefined) createElementResult.textContent = text;
    return createElementResult;
  };
  const handleActionAtual2 = (text, index, cls = "ds-button") => {
    const handleActionResult = handleAction("button", cls, text);
    handleActionResult.type = "button";
    handleActionResult.onclick = index;
    return handleActionResult;
  };
  const status = {
    pending: "Pendente",
    in_progress: "Em andamento",
    submitted: "Entregue",
    completed: "Concluída",
    returned: "Devolvida para revisão",
  };
  const fmt = (value) =>
    Number(value || 0).toLocaleString("pt-BR", {
      maximumFractionDigits: 1,
    });
  const yearLabel = (value) => {
    const matchResult = String(value || "").match(/^(\d+)\s*(EF|EM)$/i);
    return matchResult
      ? matchResult[1] +
          "º ano do Ensino " +
          (matchResult[2].toUpperCase() === "EF" ? "Fundamental" : "Médio")
      : String(value || "");
  };
  const minutes = (value) => fmt(Number(value || 0) / 60) + " min";
  const date = (value) =>
    value
      ? new Date(value.replace(" ", "T") + "Z").toLocaleString("pt-BR", {
          timeZone: "America/Araguaina",
          dateStyle: "short",
          timeStyle: "short",
        })
      : "Sem prazo";
  function headers(session) {
    const dataAtual2 = {
      "Content-Type": "application/json",
    };
    const value = session.data || {};
    if (session.tipo === "admin") {
      if (value.token) dataAtual2["X-Admin-Token"] = value.token;
      if (value.learning_admin_token)
        dataAtual2["X-Learning-Token"] = value.learning_admin_token;
    } else if (session.tipo === "aluno") {
      dataAtual2["X-Learning-Token"] = value.learning_token || "";
      dataAtual2["X-Student-Id"] = value.id;
    } else dataAtual2.Authorization = "Bearer " + (value.access_token || "");
    return dataAtual2;
  }
  // Invalidate only the signed read-only bonus projection; never add points in the browser.
  function refreshBonus(value) {
    const credited = Array.isArray(value)
      ? value.some((row) => Number(row?.task_bonus?.added_points_milli) > 0)
      : Number(value?.task_bonus?.added_points_milli) > 0;
    if (credited)
      try {
        window.DMTaskBonusRanking?.refresh();
      } catch {
        /* A saved delivery remains saved if the visual counter refresh fails. */
      }
  }
  function client(session) {
    const controller = new AbortController();
    return {
      close: () => controller.abort(),
      call: async (action, args = {}, post = false) => {
        const response = await fetch(
          getApiUrl(
            "/api/school.php?" +
              new URLSearchParams({
                action,
                ...(post ? {} : args),
              }),
          ),
          {
            method: post ? "POST" : "GET",
            headers: headers(session),
            body: post ? JSON.stringify(args) : undefined,
            signal: controller.signal,
            cache: "no-store",
            credentials: "same-origin",
          },
        );
        const json = await response.json();
        if (!response.ok || json.status !== "success")
          throw Error(json.message || "Não foi possível concluir.");
        refreshBonus(json.data);
        return json.data;
      },
    };
  }
  let fieldSerial = 0;
  function input(
    form,
    name,
    label,
    type = "text",
    value = "",
    required = false,
  ) {
    const handleActionResult = handleAction("label", "ds-field"),
      caption = handleAction("span", null, label);
    caption.id = "ds-field-" + ++fieldSerial;
    handleActionResult.append(caption);
    const handleActionResultAtual2 = handleAction(
      type === "textarea" ? "textarea" : type === "select" ? "select" : "input",
    );
    if (type !== "textarea" && type !== "select")
      handleActionResultAtual2.type = type;
    handleActionResultAtual2.name = name;
    handleActionResultAtual2.setAttribute("aria-labelledby", caption.id);
    handleActionResultAtual2.value = value ?? "";
    handleActionResultAtual2.required = required;
    if (type === "textarea") handleActionResultAtual2.rows = 5;
    handleActionResult.append(handleActionResultAtual2);
    form.append(handleActionResult);
    return handleActionResultAtual2;
  }
  function opt(select, value, text) {
    const handleActionResult = handleAction("option", null, text);
    handleActionResult.value = value;
    select.append(handleActionResult);
    return handleActionResult;
  }
  function data(form) {
    return Object.fromEntries(new FormData(form));
  }
  function table(root, cols, rows) {
    const wrap = handleAction("div", "ds-table-wrap"),
      handleActionResult = handleAction("table", "ds-table"),
      head = handleAction("thead"),
      handleActionResultAtual2 = handleAction("tr");
    cols.forEach((item) => {
      const cell = handleAction("th");
      if (item instanceof Node) cell.append(item);
      else cell.textContent = item;
      handleActionResultAtual2.append(cell);
    });
    head.append(handleActionResultAtual2);
    handleActionResult.append(head);
    const body = handleAction("tbody");
    rows.forEach((values) => {
      const row = handleAction("tr");
      values.forEach((item) => {
        const handleActionResultAtual3 = handleAction("td");
        if (item instanceof Node) handleActionResultAtual3.append(item);
        else handleActionResultAtual3.textContent = item ?? "—";
        row.append(handleActionResultAtual3);
      });
      body.append(row);
    });
    handleActionResult.append(body);
    wrap.append(handleActionResult);
    root.append(wrap);
    return handleActionResult;
  }
  function csv(name, columns, rows) {
    const cell = (value) =>
      '"' +
      String(value ?? "")
        .replace(/^[=+\-@\t\r]/, "' $&")
        .replace(/"/g, '""') +
      '"';
    const url = URL.createObjectURL(
      new Blob(
        [
          "\ufeff" +
            [columns, ...rows]
              .map((item) => item.map(cell).join(";"))
              .join("\r\n"),
        ],
        {
          type: "text/csv;charset=utf-8",
        },
      ),
    );
    const handleActionResult = handleAction("a");
    handleActionResult.href = url;
    handleActionResult.download = name + ".csv";
    handleActionResult.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
  function totals(report) {
    const kinds = {
      fechada: {
        answered: 0,
        correct: 0,
        partial: 0,
        incorrect: 0,
        first_average: null,
      },
      flashcard: {
        answered: 0,
        correct: 0,
        partial: 0,
        incorrect: 0,
        first_average: null,
      },
      aberta: {
        answered: 0,
        correct: 0,
        partial: 0,
        incorrect: 0,
        first_average: null,
      },
    };
    for (const optionalValue of report.items || [])
      if (kinds[optionalValue.kind])
        kinds[optionalValue.kind] = { ...kinds[optionalValue.kind], ...optionalValue };
    return kinds;
  }
  function reportSummary(root, index) {
    const totalsResult = totals(index),
      handleActionResult = handleAction("div", "ds-metrics");
    for (const [label, value] of [
      ["Resumo", minutes(index.seconds?.summary_seconds)],
      ["Videoaula", minutes(index.seconds?.video_seconds)],
      ["Página", minutes(index.seconds?.page_seconds)],
      [
        "Fechadas · 1ª resposta",
        fmt(totalsResult.fechada.answered) +
          " feitas · " +
          fmt(totalsResult.fechada.correct) +
          " corretas",
      ],
      [
        "Flashcards · 1ª resposta",
        fmt(totalsResult.flashcard.answered) +
          " feitos · " +
          fmt(totalsResult.flashcard.correct) +
          " “acertei”",
      ],
      [
        "Abertas · 1ª resposta",
        fmt(totalsResult.aberta.answered) +
          " feitas · " +
          fmt(totalsResult.aberta.correct) +
          " nota 10",
      ],
    ]) {
      const handleActionResultAtual2 = handleAction("div");
      handleActionResultAtual2.append(
        handleAction("span", null, label),
        handleAction("strong", null, value),
      );
      handleActionResult.append(handleActionResultAtual2);
    }
    root.append(handleActionResult);
  }
  function mount(root, session, house, section = "alunos", options = {}) {
    const api = client(session);
    let alive = true,
      version = 0;
    let liveLoader = null,
      activeRequest = 0,
      refreshPending = false;
    const disposers = [];
    const dispose = () => {
      for (const optionalValue of disposers.splice(0))
        try {
          optionalValue();
        } catch {}
    };
    root.classList.add("ds-root");
    const tabs = handleAction("div", "ds-tabs"),
      page = handleAction("div"),
      message = handleAction("p", "ds-message");
    message.setAttribute("role", "status");
    message.hidden = true;
    root.replaceChildren(tabs, message, page);
    const permission = {
      alunos: "alunos",
      turmas: "turmas",
      tarefas: "tarefas",
      relatorios: "relatorios",
    };
    const permitted = (value) =>
      !Array.isArray(options.screens) ||
      options.screens.includes(permission[value]);
    function note(text) {
      if (alive) {
        message.textContent = text;
        message.hidden = false;
      }
    }
    function run(value) {
      return async (...args) => {
        try {
          await value(...args);
        } catch (error) {
          if (alive && error.name !== "AbortError") note(error.message);
        }
      };
    }
    // Atualizar consultas sem apagar a tela, os filtros ainda não aplicados ou uma edição.
    async function refreshReadView() {
      if (!alive || !liveLoader || document.hidden) return;
      if (page.contains(document.activeElement) &&
          document.activeElement.matches("input,select,textarea")) return;
      if (activeRequest) {
        refreshPending = true;
        return;
      }
      await render(liveLoader, { live: true, quiet: true });
    }
    async function render(value, { live = false, quiet = false } = {}) {
      if (!quiet) {
        dispose();
        liveLoader = live ? value : null;
        refreshPending = false;
      }
      const token = ++version;
      activeRequest = token;
      const fields = quiet ? Array.from(page.querySelectorAll("input"),
        (field) => ({ name: field.name, type: field.type, value: field.value })) : [];
      const expanded = quiet ? Array.from(page.querySelectorAll("details[open]"),
        (detail) => detail.querySelector("summary")?.textContent) : [];
      if (!quiet) page.replaceChildren(handleAction("p", "ds-loading", "Carregando…"));
      message.hidden = true;
      try {
        const section = handleAction("section", "ds-section");
        await value(section);
        if (alive && token === version) {
          // O usuário pode começar a editar um filtro enquanto a consulta está em curso.
          if (quiet && page.contains(document.activeElement) &&
              document.activeElement.matches("input,select,textarea")) return;
          page.replaceChildren(section);
          if (quiet) {
            page.querySelectorAll("input").forEach((field, index) => {
              const saved = fields[index];
              if (saved && saved.name === field.name && saved.type === field.type) {
                field.value = saved.value;
                if (field.type === "search") field.dispatchEvent(new Event("input"));
              }
            });
            page.querySelectorAll("details").forEach((detail) => {
              detail.open = expanded.includes(detail.querySelector("summary")?.textContent);
            });
          }
        }
      } catch (error) {
        if (alive && token === version && error.name !== "AbortError") {
          if (quiet) note(error.message);
          else page.replaceChildren(handleAction("p", "ds-error", error.message));
        }
      } finally {
        if (alive && token === version) {
          activeRequest = 0;
          if (refreshPending) {
            refreshPending = false;
            refreshReadView();
          }
        }
      }
    }
    window.addEventListener("focus", refreshReadView);
    window.addEventListener("dm-learning-changed", refreshReadView);
    document.addEventListener("visibilitychange", refreshReadView);
    const readTimer = window.setInterval(refreshReadView, 15000);
    const stopLiveReads = () => {
      clearInterval(readTimer);
      window.removeEventListener("focus", refreshReadView);
      window.removeEventListener("dm-learning-changed", refreshReadView);
      document.removeEventListener("visibilitychange", refreshReadView);
    };
    function heading(element, title, description) {
      const handleActionResult = handleAction("div", "ds-heading");
      handleActionResult.append(handleAction("h2", null, title));
      if (description)
        handleActionResult.append(handleAction("p", null, description));
      element.append(handleActionResult);
      return handleActionResult;
    }
    function toolbar(element, ...buttons) {
      const bar = handleAction("div", "ds-actions");
      bar.append(...buttons);
      element.append(bar);
      return bar;
    }
    function empty(element, text) {
      element.append(handleAction("p", "ds-empty", text));
    }
    function saveForm(element, form, text, action) {
      const submit = handleAction("button", "ds-button ds-primary", text);
      submit.type = "submit";
      form.append(submit);
      form.onsubmit = async (event) => {
        event.preventDefault();
        submit.disabled = true;
        try {
          await action(data(form));
        } catch (err) {
          note(err.message);
        } finally {
          if (alive) submit.disabled = false;
        }
      };
      element.append(form);
    }
    const ctx = {
      api,
      session,
      house,
      options,
      render,
      heading,
      toolbar,
      empty,
      saveForm,
      note,
      run,
      permitted,
      alive: () => alive,
      cleanup: (value) => disposers.push(value),
    };
    ctx.openStudentRecord = (value, back) =>
      window.DMSchoolSections.reports(ctx).studentReport(value, {
        action: "student-record",
        back,
        backLabel: "Voltar aos alunos",
      });
    ctx.openClassRecord = (value, back) =>
      window.DMSchoolSections.reports(ctx).classRecord(value, {
        action: "class-record",
        studentAction: permitted("alunos")
          ? "student-record"
          : "student-period-report",
        back,
      });
    const region = ["alunos", "turmas"].includes(section)
      ? "roster"
      : section === "tarefas"
        ? "tasks"
        : "reports";
    if (!permitted(section) || !window.DMSchoolSections?.[region]) {
      empty(page, "Atualize a página para abrir esta área.");
      return () => {
        alive = false;
        stopLiveReads();
        api.close();
        root.replaceChildren();
      };
    }
    const module = window.DMSchoolSections[region](ctx);
    if (region === "roster") {
      for (const [key, label] of [
        ["alunos", "Alunos"],
        ["turmas", "Turmas"],
      ].filter(([key]) => permitted(key)))
        tabs.append(
          handleActionAtual2(label, () => {
            tabs
              .querySelectorAll("button")
              .forEach((item) =>
                item.classList.toggle("ds-active", item.textContent === label),
              );
            module[key === "alunos" ? "students" : "classes"]();
          }),
        );
      if (section === "alunos" && options.studentId)
        ctx.openStudentRecord(
          options.studentId,
          options.onBack || module.students,
        );
      else module[section === "alunos" ? "students" : "classes"]();
    } else module[region === "tasks" ? "tasks" : "reports"]();
    return () => {
      alive = false;
      ++version;
      stopLiveReads();
      dispose();
      api.close();
      root.replaceChildren();
    };
  }
  const goalText = (event) =>
    (event.nome ? event.nome + " · " : "") +
    {
      closed: "Questões fechadas",
      flashcard: "Flashcards",
      open: "Questões abertas",
      summary_seconds: "Resumo",
      video_seconds: "Videoaula",
    }[event.kind] +
    ": " +
    (event.kind.endsWith("seconds")
      ? minutes(event.current) + " / " + minutes(event.target)
      : fmt(event.current) + " / " + fmt(event.target));
  function mountStudent(root, session, onOpen, options = {}) {
    const api = client(session),
      drafts = new Map();
    let alive = true,
      version = 0,
      rows = [],
      filter = "pending",
      page = 0,
      selected = null,
      loading = false,
      reloadPending = false;
    root.classList.add("ds-root", "ds-student");
    if (options.standalone) root.classList.add("ds-inbox");
    const title = handleAction("div", "ds-heading"),
      refresh = handleActionAtual2("Atualizar tarefas", () => load(true)),
      tabs = handleAction("div", "ds-tabs ds-task-filters"),
      list = handleAction("div"),
      notice = handleAction("p", "ds-message");
    notice.hidden = true;
    notice.setAttribute("role", "status");
    title.append(handleAction("h2", null, "Minhas tarefas"), refresh);
    root.replaceChildren(title, tabs, notice, list);
    const buttons = {};
    for (const [optionalValue, label] of [
      ["pending", "Pendentes"],
      ["completed", "Concluídas"],
      ["all", "Todas"],
    ]) {
      const button = handleActionAtual2(label, () => {
        filter = optionalValue;
        page = 0;
        selected = null;
        render();
      });
      buttons[optionalValue] = {
        button,
        label,
      };
      tabs.append(button);
    }
    const done = (value) => !!value.state?.completed;
    const automatic = (value) => !!value.state?.goals?.length;
    function actionLabel(value) {
      const kinds =
        value.state?.goals?.map((resultado) => resultado.kind) || [];
      if (kinds.length !== 1)
        return automatic(value) ? "Realizar atividades" : "Abrir material";
      return (
        {
          closed: "Realizar questões fechadas",
          flashcard: "Realizar flashcards",
          open: "Realizar questões abertas",
          summary_seconds: "Ler resumo",
          video_seconds: "Assistir videoaula",
        }[kinds[0]] || "Realizar atividades"
      );
    }
    function message(text) {
      notice.textContent = text;
      notice.hidden = !text;
    }
    function lesson(value) {
      return (
        options.canOpen !== false &&
        value.lesson_id &&
        value.curso_id &&
        Number(value.material_available ?? 1) !== 0
      );
    }
    function openLesson(value) {
      if (alive && lesson(value))
        onOpen({
          cursoId: value.curso_id,
          aulaId: value.lesson_id,
          guiaId: value.guia_id || null,
        });
    }
    function summary(card, index) {
      const state = index.state,
        labels = {
          closed: "Questões fechadas",
          flashcard: "Flashcards",
          open: "Questões abertas",
          summary_seconds: "Resumo",
          video_seconds: "Videoaula",
        };
      const kinds = (state.goals || [])
        .map((item) => labels[item.kind])
        .filter(Boolean);
      const kind = kinds.length ? kinds.join(" e ") : "Atividade escrita";
      const material = (
        index.lesson_title ||
        index.material?.nome_arquivo ||
        index.guia_nome ||
        "Atividade"
      )
        .replace(/^Aula\s+\d+\s*[—–-]\s*/i, "")
        .replace(/\s*\(\d+\s+questões?\)\s*$/i, "");
      card.append(
        handleAction("h3", "ds-task-heading", kind + " — " + material),
      );
      if (index.sender_name)
        card.append(
          handleAction(
            "p",
            "ds-hint ds-task-sender",
            "Enviada por: " + index.sender_name,
          ),
        );
      const meta = handleAction("div", "ds-task-meta");
      meta.append(
        handleAction("span", "ds-hint", "Prazo: " + date(index.due_at)),
        handleAction(
          "span",
          "ds-task-state" + (done(index) ? " ds-task-done" : ""),
          status[state.status] + (state.late ? " · Prazo vencido" : ""),
        ),
      );
      for (const optionalValue of state.goals || []) {
        const progress = handleAction(
          "span",
          "ds-task-progress",
          state.goals.length === 1
            ? goalText(optionalValue).split(": ")[1]
            : goalText(optionalValue),
        );
        progress.setAttribute("aria-label", goalText(optionalValue));
        meta.append(progress);
      }
      card.append(meta);
    }
    function render() {
      if (!alive) return;
      root.hidden = !options.standalone && !rows.length && !loading;
      const complete = rows.filter(done).length;
      for (const [optionalValue, optionalValueAtual2] of Object.entries(
        buttons,
      )) {
        optionalValueAtual2.button.textContent =
          optionalValueAtual2.label +
          " (" +
          (optionalValue === "all"
            ? rows.length
            : optionalValue === "completed"
              ? complete
              : rows.length - complete) +
          ")";
        optionalValueAtual2.button.classList.toggle(
          "ds-active",
          filter === optionalValue,
        );
        optionalValueAtual2.button.setAttribute(
          "aria-pressed",
          String(filter === optionalValue),
        );
      }
      list.replaceChildren();
      if (selected !== null) {
        const row = rows.find(
          (rowAtual2) => String(rowAtual2.id) === String(selected),
        );
        if (row) {
          detail(row);
          return;
        }
        selected = null;
      }
      const shown = rows.filter(
        (row) =>
          filter === "all" || (filter === "completed" ? done(row) : !done(row)),
      );
      if (!shown.length) {
        const box = handleAction("div", "ds-task");
        box.append(
          handleAction(
            "p",
            "ds-empty",
            !rows.length
              ? "Nenhuma tarefa recebida ainda. As atividades enviadas pelos professores aparecerão aqui."
              : filter === "completed"
                ? "Você ainda não tem tarefas concluídas."
                : "Nenhuma tarefa pendente.",
          ),
        );
        list.append(box);
        return;
      }
      page = Math.min(page, Math.max(0, Math.ceil(shown.length / 20) - 1));
      for (const optionalValue of shown.slice(page * 20, (page + 1) * 20)) {
        const card = handleAction("article", "ds-task");
        summary(card, optionalValue);
        const actions = handleAction("div", "ds-row-actions");
        if (lesson(optionalValue)) {
          if (optionalValue.material?.kind === "study_plan") {
            for (const part of optionalValue.material.parts)
              actions.append(
                handleActionAtual2(
                  part.nome || actionLabel(optionalValue),
                  () =>
                    onOpen({
                      cursoId: optionalValue.curso_id,
                      aulaId: optionalValue.lesson_id,
                      guiaId: part.guia_id || null,
                    }),
                  "ds-button ds-primary",
                ),
              );
          } else
            actions.append(
              handleActionAtual2(
                automatic(optionalValue)
                  ? actionLabel(optionalValue)
                  : optionalValue.guia_id
                    ? "Abrir material"
                    : "Abrir aula",
                () => openLesson(optionalValue),
                "ds-button ds-primary",
              ),
            );
        }
        if (!automatic(optionalValue))
          actions.append(
            handleActionAtual2("Enviar atividade escrita", () => {
              selected = optionalValue.id;
              render();
            }),
          );
        card.append(actions);
        list.append(card);
      }
      if (shown.length > 20) {
        const pages = handleAction("div", "ds-task-pager"),
          prev = handleActionAtual2("Anterior", () => {
            page--;
            render();
          }),
          next = handleActionAtual2("Próxima", () => {
            page++;
            render();
          });
        prev.disabled = page === 0;
        next.disabled = (page + 1) * 20 >= shown.length;
        pages.append(
          prev,
          handleAction(
            "span",
            null,
            "Página " + (page + 1) + " de " + Math.ceil(shown.length / 20),
          ),
          next,
        );
        list.append(pages);
      }
    }
    function detail(item) {
      if (automatic(item)) {
        selected = null;
        render();
        return;
      }
      const card = handleAction("article", "ds-task"),
        state = item.state;
      card.append(
        handleActionAtual2("Voltar à lista", () => {
          selected = null;
          render();
        }),
      );
      summary(card, item);
      if (item.material?.kind === "vestibulares") {
        const link = handleAction(
          "a",
          "ds-button ds-primary",
          "Abrir material de Vestibulares",
        );
        link.href = item.material.html_url;
        link.target = "_blank";
        link.rel = "noopener";
        card.append(link);
      } else if (lesson(item))
        card.append(
          handleActionAtual2(
            item.guia_id ? "Abrir material indicado" : "Abrir aula indicada",
            () => openLesson(item),
            "ds-button ds-primary",
          ),
        );
      if (state.goals?.length) {
        const goals = handleAction("div", "ds-task-goals");
        goals.append(handleAction("h4", null, "O que falta concluir na aula"));
        for (const optionalValue of state.goals)
          goals.append(
            handleAction("p", "ds-goal-line", goalText(optionalValue)),
          );
        card.append(
          goals,
          handleAction(
            "p",
            "ds-hint",
            "As metas se atualizam com seu progresso na aula. Você não precisa marcá-las manualmente.",
          ),
        );
      }
      if (state.delivery) {
        card.append(
          handleAction(
            "p",
            "ds-hint",
            "Entrega registrada em " + date(state.delivery.submitted_at),
          ),
        );
        if (state.delivery.grade !== null)
          card.append(
            handleAction("strong", null, "Nota: " + fmt(state.delivery.grade)),
          );
        if (state.delivery.feedback)
          card.append(
            handleAction("div", "ds-feedback", state.delivery.feedback),
          );
      }
      const form = handleAction("form", "ds-form"),
        answer = input(
          form,
          "response",
          "Entrega escrita (mínimo de 20 caracteres)",
          "textarea",
          drafts.get(String(item.id)) ?? state.delivery?.response ?? "",
          true,
        ),
        counter = handleAction("p", "ds-hint");
      answer.minLength = 20;
      answer.maxLength = 20000;
      const count = () =>
        (counter.textContent =
          answer.value.trim().length + " caracteres · mínimo de 20");
      answer.oninput = () => {
        drafts.set(String(item.id), answer.value);
        count();
      };
      count();
      form.append(counter);
      const msg = handleAction("p", "ds-message");
      msg.hidden = true;
      msg.setAttribute("role", "status");
      const submit = handleAction(
        "button",
        "ds-button ds-primary",
        state.delivery ? "Reenviar resposta" : "Enviar resposta",
      );
      submit.type = "submit";
      form.append(submit, msg);
      form.onsubmit = async (event) => {
        event.preventDefault();
        if (answer.value.trim().length < 20) {
          msg.hidden = false;
          msg.textContent = "Escreva pelo menos 20 caracteres antes de enviar.";
          return;
        }
        submit.disabled = true;
        try {
          await api.call(
            "task-submit",
            {
              id: item.id,
              response: answer.value,
            },
            true,
          );
          if (!alive) return;
          drafts.delete(String(item.id));
          selected = null;
          message(
            "Resposta enviada e salva. Confira a situação na lista de tarefas.",
          );
          await load(true);
        } catch (err) {
          if (alive && err.name !== "AbortError") {
            msg.hidden = false;
            msg.textContent = err.message;
          }
        } finally {
          if (alive) submit.disabled = false;
        }
      };
      card.append(form);
      list.append(card);
    }
    async function load(manual = false) {
      if (!alive) return;
      if (loading) {
        // Uma gravação durante a consulta exige uma leitura depois dela.
        // Nunca empilhar consultas ou perder a atualização mais recente.
        reloadPending ||= manual;
        return;
      }
      const token = ++version;
      loading = true;
      refresh.disabled = true;
      refresh.textContent = "Atualizando…";
      root.hidden = false;
      root.setAttribute("aria-busy", "true");
      try {
        const next = await api.call("student-tasks");
        if (!alive || token !== version) return;
        rows = next;
        message("");
        render();
      } catch (error) {
        if (alive && token === version && error.name !== "AbortError")
          message(error.message);
      } finally {
        if (alive && token === version) {
          loading = false;
          refresh.disabled = false;
          refresh.textContent = "Atualizar tarefas";
          root.setAttribute("aria-busy", "false");
          root.hidden = !options.standalone && !rows.length;
          if (reloadPending) {
            reloadPending = false;
            load();
          }
        }
      }
    }
    load();
    const visible = () => {
      if (!document.hidden) load();
    };
    const progressChanged = () => {
      if (!document.hidden) load(true);
    };
    document.addEventListener("visibilitychange", visible);
    window.addEventListener("focus", visible);
    window.addEventListener("dm-learning-changed", progressChanged);
    const timer = options.standalone
      ? window.setInterval(visible, 15000)
      : null;
    return () => {
      alive = false;
      ++version;
      api.close();
      if (timer) clearInterval(timer);
      document.removeEventListener("visibilitychange", visible);
      window.removeEventListener("focus", visible);
      window.removeEventListener("dm-learning-changed", progressChanged);
      root.replaceChildren();
    };
  }
  window.DMSchoolUi = Object.freeze({
    el: handleAction,
    b: handleActionAtual2,
    input,
    opt,
    table,
    csv,
    fmt,
    date,
    minutes,
    yearLabel,
    totals,
    reportSummary,
    goalText,
    status,
  });
  window.DMSchool = Object.freeze({
    mount,
    mountStudent,
  });
})();
